var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-content" }, [
    _vm.uploaderDes
      ? _c("div", { staticClass: "video-header" }, [
          _c("div", { staticClass: "video-top-bg" }, [
            _c("img", { attrs: { src: _vm.uploaderDes.v_picurl } }),
            _vm._v(" "),
            _c("div", { staticClass: "mask" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "header-wrap" }, [
            _c("header", [
              _c("div", { staticClass: "icon-gather-left" }, [
                _c("i", {
                  staticClass: "sub-page-back",
                  attrs: { uigs: "head_back" },
                  on: { click: _vm.backPrev },
                }),
              ]),
              _vm._v(" "),
              _c("h4", [_vm._v("作者视频")]),
              _vm._v(" "),
              _c("div", { staticClass: "icon-gather-right" }, [
                _c("i", {
                  staticClass: "sub-page-home",
                  attrs: { uigs: "head_home" },
                  on: { click: _vm.jump2Home },
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "sub-page-search",
                  attrs: { uigs: "head_search" },
                  on: { click: _vm.jump2Search },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "img-flex space-between",
                attrs: { href: _vm.uploaderDes.pageurl },
              },
              [
                _c("div", { staticClass: "img-layout" }, [
                  _c("i", { staticClass: "img-height img-square" }, [
                    _c("img", { attrs: { src: _vm.uploaderDes.v_picurl } }),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "v-tag" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-layout" }, [
                  _c("h4", { staticClass: "fz-big" }, [
                    _vm._v(_vm._s(_vm.uploaderDes.name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "citeurl" }, [
                    _vm.uploaderDes.fans_num
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.uploaderDes.fans_num) + "粉丝"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.uploaderDes.video_count
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.uploaderDes.video_count) + "个视频"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "video-wiki clamp2" }, [
              _c("span", [_vm._v(_vm._s(_vm.uploaderDes.introduction))]),
              _vm._v(" "),
              false
                ? _c("a", { staticClass: "more", attrs: { href: "#" } }, [
                    _vm._v("详情"),
                  ])
                : _vm._e(),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "vrResult video-list video-list-top" }, [
      _c("div", { staticClass: "video-tab" }, [
        _c("ul", [
          _c(
            "li",
            {
              class: ["fz-title", { active: _vm.orderActive }],
              on: {
                click: function ($event) {
                  return _vm.getShortVideoByOrder("1")
                },
              },
            },
            [_vm._v("\n          最新\n        ")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: ["fz-title", { active: !_vm.orderActive }],
              on: {
                click: function ($event) {
                  return _vm.getShortVideoByOrder("0")
                },
              },
            },
            [_vm._v("\n          最热\n        ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "select-common select-common-noline" }, [
          _c("i", [
            _c("img", {
              attrs: {
                src:
                  "https://dlweb.sogoucdn.com/video/wap/static/img/logo/" +
                  _vm.uploaderDes.icon,
                width: "14",
              },
            }),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "select-text" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.uploaderDes.siteName) + "\n        "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-img-flex" },
        _vm._l(_vm.uploaderShortVideoList, function (item, i) {
          return _c(
            "a",
            {
              key: "video" + i,
              staticClass: "img-flex space-between",
              attrs: { href: item.playlink },
            },
            [
              _c("div", { staticClass: "img-layout" }, [
                _c("i", { staticClass: "img-height" }, [
                  _c("img", { attrs: { src: item.v_picurl } }),
                  _vm._v(" "),
                  _c("span", { staticClass: "about-tag" }, [
                    _vm._v(_vm._s(item.duration)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-layout" }, [
                _c("h4", { staticClass: "fz-title clamp2" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "citeurl" }, [
                  _c("span", { staticClass: "ellipsis" }, [
                    _vm._v(_vm._s(item.pub_date)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "ellipsis" }, [
                    _vm._v(_vm._s(item.play) + "人次观看"),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showMoreTag
        ? _c(
            "a",
            {
              staticClass: "slide-down",
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.showMoreVideo },
            },
            [_vm._v("查看更多")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }